(function (angular) {
    'use strict';

    angular.module('GorillaBoy')
    .factory('ServiceHelper', [
        'EndpointService',
        ServiceHelper
    ]);

    function ServiceHelper (EndpointService) {

        function interpolateUrl (url, params, isNewAPI) {
            var context = angular.extend({apiRoot: EndpointService.endpoint(isNewAPI) }, params || {});

            // Replace each label in the URL (e.g. :userID)
            url = url.replace(/:([a-z]\w*)/gi, function ($0, label) {
                return context[label] || '';
            });

            // Strip out any repeating slashes (but NOT the http:// version).
            url = url.replace( /(^|[^:])[\/]{2,}/g, '$1/');

            // Strip out any trailing slash.
            url = url.replace(/\/+$/i, '');

            return url;
        }

        function formatFailure (data, status, statusText) {
            var
                serverMessage = data && (data.message || data.Message),
                message = status + ' ' + statusText;

            if (serverMessage) {
                message += ' (' + serverMessage + ')';
            }

            return message;
        }


        // Return public API for ServiceHelper
        return {
            interpolateUrl: interpolateUrl,
            formatFailure: formatFailure
        };
    }

}(angular));
